import {
  EntityAction,
  TAddPayload,
  TUpdatePayload,
  TDeletePayload,
  EntityState,
  TReplacePayload,
} from '../types';

import {replaceOrInsertItem} from './replaceOrInsertItem';
import {updateItem} from './updateItem';
import {deleteItem} from './deleteItem';
import {replaceItem} from './replaceItem';

export const createEntitydReducer = <
  TData extends Record<TIdKey, any>,
  TEntityName extends string = any,
  TIdKey extends keyof TData = keyof TData
>(
  entityName: TEntityName,
  idKey: TIdKey,
) => {
  return (
    state: EntityState<TData> = {data: [], version: 0},
    action: EntityAction<TData, TIdKey, TEntityName>,
  ): EntityState<TData> => {
    switch (action.type) {
      case `ADD_${entityName}`: {
        const payload = action.payload as TAddPayload<TData>;
        const draftData = [...state.data];
        payload.data.forEach(item => {
          replaceOrInsertItem(idKey, draftData, item);
        });

        return {data: draftData, version: state.version /*+ 1*/};
      }
      case `DELETE_${entityName}`: {
        const payload = action.payload as TDeletePayload<TData, TIdKey>;
        let draftData = state.data;

        payload.id.forEach(id => {
          draftData = deleteItem(idKey, draftData, id);
        });

        return {data: draftData, version: state.version /*+ 1*/};
      }
      case `UPDATE_${entityName}`: {
        const payload = action.payload as TUpdatePayload<TData, TIdKey>;
        const draftData = updateItem(
          idKey,
          state.data,
          payload.data,
          payload.id,
        );
        return {data: draftData, version: state.version /*+ 1*/};
      }
      case `REPLACE_${entityName}`: {
        const payload = action.payload as TReplacePayload<TData>;
        const draftData = [...state.data];
        payload.data.forEach(item => {
          replaceItem(idKey, draftData, item);
        });
        return {data: draftData, version: state.version /*+ 1*/};
      }
      case 'RESET':
      case `RESET_${entityName}`: {
        return {data: [], version: state.version /*+ 1*/};
      }
    }

    return state;
  };
};
